var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppFooter',{staticClass:"plot-footer",attrs:{"footer-menu":_vm.footerMenu,"site-name":"Plot.gr","creation-year":"2018","show-powered-by":"","privacy-link":"/information/faq/privacy/","available-locales":_vm.availableLocales}})}
var staticRenderFns = []

export { render, staticRenderFns }